export const buildRynReplayIssuePlayerQuery = (input: {
  sampleSessionId: string;
  sampleOffsetMs: number;
  app?: string;
}): Record<string, string> => {
  const query: Record<string, string> = {};
  if (input.app?.trim()) {
    query['app'] = input.app.trim();
  }
  if (input.sampleOffsetMs > 0) {
    query['t'] = String(Math.floor(input.sampleOffsetMs / 1000));
  }
  return query;
};
